export var ChargesForDamagedMissingItemsIA = function ChargesForDamagedMissingItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "nIK7TZ",
        defaultMessage: [{
          "type": 0,
          "value": "Kosten voor beschadigde of ontbrekende artikelen"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "5P7k5e",
        defaultMessage: [{
          "type": 0,
          "value": "Voor bestellingen die worden geplaatst met een betalingstermijn van netto 60 dagen worden alle gemelde artikelen verwijderd van je oorspronkelijke factuur. Voor bestellingen die al bij verzending in rekening zijn gebracht storten we het bedrag van de gemelde artikelen terug op de opgeslagen kaart."
        }]
      }), strictLocalize({
        id: "g05TNU",
        defaultMessage: [{
          "type": 0,
          "value": "Als je ervoor kiest om artikelen te vervangen, wordt er een nieuwe bestelling aangemaakt met deze vervangingen. Vervangende artikelen worden op de nieuwe vervaldatum van je factuur apart in rekening gebracht zodra de vervangende bestelling wordt verzonden."
        }]
      }), strictLocalize({
        id: "2RyUSl",
        defaultMessage: [{
          "type": 0,
          "value": "Neem contact met ons op voor andere vragen."
        }]
      })];
    }
  };
};